import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BeerConsumptionWeekService {

  constructor() { }

  getMaxConsumptionWeek(data: any[]): { weekRange: string, total: number, details: any } {
    const consumoPorSemana: { 
      [key: string]: { total: number, detalles: { [key: string]: number }, startDate: string, endDate: string } 
    } = {};

    data.forEach(entry => {
      const { year, week, month } = entry;
      const { startDate, endDate } = this.getWeekRange(year, week);
      const weekKey = `${startDate} a ${endDate}`; // Formato: Rango de fechas

      const consumoTotal: any = Object.values(entry.beertypes).reduce((sum, beer: any) => sum + beer.consume, 0);

      if (!consumoPorSemana[weekKey]) {
        consumoPorSemana[weekKey] = { total: 0, detalles: {}, startDate, endDate };
      }

      consumoPorSemana[weekKey].total += consumoTotal;

      Object.values(entry.beertypes).forEach((beer: any) => {
        if (!consumoPorSemana[weekKey].detalles[beer.type]) {
          consumoPorSemana[weekKey].detalles[beer.type] = 0;
        }
        consumoPorSemana[weekKey].detalles[beer.type] += beer.consume;
      });
    });

    if(Object.keys(consumoPorSemana).length != 0){
      const semanaMax = Object.keys(consumoPorSemana).reduce((max, key) =>
        consumoPorSemana[key].total > consumoPorSemana[max].total ? key : max
      );
  
      return {
        weekRange: semanaMax,
        total: consumoPorSemana[semanaMax].total,
        details: consumoPorSemana[semanaMax].detalles
      };
    }else{
      return {
        weekRange: "",
        total: 0,
        details: {}
      };
    }
  }

  private getWeekRange(year: number, week: number): { startDate: string, endDate: string } {
    // Obtener el 4 de enero del año dado (ISO 8601: Semana 1 siempre contiene el primer jueves del año)
    const fourthOfJanuary = new Date(year, 0, 4);
    const dayOfWeek = fourthOfJanuary.getDay(); // 0=Domingo, 1=Lunes, ..., 6=Sábado
  
    // Ajustar para encontrar el lunes de la primera semana del año
    const firstMonday = new Date(fourthOfJanuary);
    firstMonday.setDate(fourthOfJanuary.getDate() - (dayOfWeek - 1));
  
    // Calcular el lunes de la semana deseada
    const startDate = new Date(firstMonday);
    startDate.setDate(firstMonday.getDate() + (week - 1) * 7);
  
    // Calcular el domingo de esa semana
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
  
    // Formatear la fecha a "DD/MM/YYYY"
    const format = (d: Date) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  
    return { 
      startDate: format(startDate), 
      endDate: format(endDate) 
    };
  }
  
  
  
}
